// Container-agnostic hover-actions binder. Attaches delegated bubble-hover
// listeners on the scroll container and positions the single global
// [data-hover-actions] element via viewport-fixed coords.

export const setupHoverActions = (container) => {
  if (!container || container.__hoverActionsBound) return
  container.__hoverActionsBound = true

  // Both the full chat page (ChatMain) and the overlay drawer (ChatDrawer)
  // render their own [data-hover-actions]. A document-wide querySelector
  // would pick whichever lives earlier in the DOM — often the drawer's,
  // which is display:none when closed. Scope to the container's chat
  // root once, then cache the resolved element behind an isConnected
  // guard so mouseover (one of the chattiest DOM events) stays cheap.
  const _scope =
    container.closest('[data-key="ChatMain"], [data-key="ChatDrawer"]') ||
    document
  let _ha = null
  const _getActions = () =>
    _ha && _ha.isConnected
      ? _ha
      : (_ha = _scope.querySelector('[data-hover-actions]'))

  const _showActions = (bubble) => {
    const row = bubble.closest('[data-msg-id]')
    if (!row) return
    const ha = _getActions()
    if (!ha) return

    const msgId = row.getAttribute('data-msg-id')
    const isMine = row.getAttribute('data-mine') === 'true'
    ha.setAttribute('data-active-msg', msgId)

    const bRect = bubble.getBoundingClientRect()

    let top = bRect.bottom + 2
    let left = isMine ? bRect.right - ha.offsetWidth : bRect.left

    if (top + ha.offsetHeight > window.innerHeight - 4) {
      top = bRect.top - ha.offsetHeight - 2
    }
    if (left + ha.offsetWidth > window.innerWidth - 4) {
      left = window.innerWidth - ha.offsetWidth - 4
    }
    if (left < 4) left = 4

    ha.style.top = top + 'px'
    ha.style.left = left + 'px'
    ha.style.opacity = '1'
    ha.style.pointerEvents = 'auto'
  }

  const _hideActions = () => {
    const ha = _getActions()
    if (!ha || ha.hasAttribute('data-hover-lock')) return
    if (ha.style.opacity === '0') return
    ha.style.opacity = '0'
    ha.style.pointerEvents = 'none'
  }

  container.addEventListener('mouseover', (ev) => {
    const bubble = ev.target.closest && ev.target.closest('[data-key="Body"]')
    if (bubble) _showActions(bubble)
  })

  container.addEventListener('mouseout', (ev) => {
    const related = ev.relatedTarget
    const ha = _getActions()
    if (ha && related && ha.contains(related)) return
    if (related && related.closest && related.closest('[data-key="Body"]')) return
    _hideActions()
  })

  container.addEventListener('scroll', _hideActions, { passive: true })
}
